import { CalendarDays, Clock } from "lucide-react";
import { Fixture } from "@tracker-bet-analystic/domain";
import { formatDateBR, formatDateTimeBR } from "@tracker-bet-analystic/domain";

interface FixtureCardProps {
  fixture: Fixture;
  /** Ação única do card. Quando ausente, o card é apenas informativo. */
  onAnalyze?: () => void;
  /** Em andamento: mostra "Criando análise..." e trava o botão. */
  analyzing?: boolean;
  /** Trava global (outra partida em análise) para impedir disparo duplo. */
  disabled?: boolean;
}

export function FixtureCard({ fixture, onAnalyze, analyzing = false, disabled = false }: FixtureCardProps) {
  return (
    <article className="card p-4 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex-1 min-w-0">
          <p className="text-xs text-[var(--color-text-muted)] uppercase tracking-wide">
            {fixture.competitionName}
          </p>
          <h3 className="font-semibold text-[var(--color-text)] truncate">
            {fixture.homeTeamName} <span className="text-[var(--color-text-muted)]">vs</span> {fixture.awayTeamName}
          </h3>
        </div>
        {fixture.status === "live" && (
          <span className="badge badge-danger flex-shrink-0" aria-label="Partida ao vivo">AO VIVO</span>
        )}
      </div>

      <div className="flex items-center gap-4 text-sm text-[var(--color-text-muted)] mb-3">
        <span className="flex items-center gap-1">
          <CalendarDays size={14} aria-hidden="true" />
          {formatDateBR(fixture.kickoffAt)}
        </span>
        <span className="flex items-center gap-1">
          <Clock size={14} aria-hidden="true" />
          {formatDateTimeBR(fixture.kickoffAt)}
        </span>
      </div>

      {fixture.venue && (
        <p className="text-sm text-[var(--color-text-muted)] mb-3">
          <span aria-hidden="true">🏟️</span> {fixture.venue}
        </p>
      )}

      {onAnalyze && (
        // `type="button"` é obrigatório: o card pode ser renderizado dentro/junto do
        // formulário de busca e um submit recarregaria a página, perdendo os resultados.
        <button
          type="button"
          className="btn btn-primary w-full"
          onClick={onAnalyze}
          disabled={disabled || analyzing}
          aria-label={`Analisar ${fixture.homeTeamName} vs ${fixture.awayTeamName}`}
        >
          {analyzing ? "Criando análise..." : "Analisar"}
        </button>
      )}
    </article>
  );
}
